module.exports = __webpack_public_path__ + "img/hot-video-tit.fa8526e2.png";